import { render, staticRenderFns } from "./social_media_ads.vue?vue&type=template&id=18eb3569&"
import script from "./social_media_ads.vue?vue&type=script&lang=js&"
export * from "./social_media_ads.vue?vue&type=script&lang=js&"
import style0 from "./social_media_ads.vue?vue&type=style&index=0&id=18eb3569&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports